import { ReportType, CentreReport } from '../../models/report/report.model';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http/src/static_response';
import { ReportUrl } from '../../shared/urls/report.url';
import { BaseService } from '../../shared/services/base.service';
import { Injectable } from '@angular/core';
import { PriceUrl } from '../../shared/urls/price.url';
import { CentreUrl } from '../../shared/urls/centre.url';
import { Utility } from '../../common/utility';

@Injectable()
export class ReportService {
  constructor(public baseService: BaseService) { }
  getReport() {
    const url = ReportUrl.GET_REPORT;
    return this.baseService.getData(url);
  }
  getCentre() {
    const url = ReportUrl.GET_CENTRE;
    return this.baseService.getData(url);
  }
  getVaccine() {
    const url = ReportUrl.GET_VACCINE;
    return this.baseService.getData(url);
  }
  getGender() {
    const url = ReportUrl.GET_GENDER;
    return this.baseService.getData(url);
  }
  getGroup() {
    const url = ReportUrl.GET_GROUP;
    return this.baseService.getData(url);
  }
  getAgeGroup() {
    const url = ReportUrl.GET_AGE_GROUP;
    return this.baseService.getData(url);
  }
  getDestination() {
    const url = ReportUrl.GET_DESTINATION;
    return this.baseService.getData(url);
  }
  getCountry() {
    const url = ReportUrl.GET_COUNTRY;
    return this.baseService.getData(url);
  }
  getOccupation() {
    const url = ReportUrl.GET_OCCUPATION;
    return this.baseService.getData(url);
  }

  getCurrencies() {
    let url = PriceUrl.GET_CURRENCIES;
    return this.baseService.getData(url);
}
  getPractitioner(){
    const url = ReportUrl.GET_PRACTITIONER;
    return this.baseService.getData(url);
  }
  getProductCategories(){
    const url = ReportUrl.GET_PRODUCT_CATEGORIES;
    return this.baseService.getData(url);
  }

  getDefaultCurrency(centreId) {
    const url = CentreUrl.GET_CENTRE + `/${centreId}`;
    return this.baseService.getData(url);
  }

}

export const formReport = {
  centre: {
    key: 'centre',
    name: 'Centre'
  },
  reportType: {
    key: 'reportType',
    name: 'Report'
  },

  startDate: {
    key: 'startDate',
    name: 'Start Date'
  },
  endDate: {
    key: 'endDate',
    name: 'End Date'
  },
  currency: {
    key: 'currency',
    name: 'Currency'
  },
  gender: {
    key: 'gender',
    name: 'Gender'
  },
  ageGroup: {
    key: 'ageGroup',
    name: 'Age Group'
  },
  group: {
    key: 'group',
    name: 'Group'
  },
  destination: {
    key: 'destination',
    name: 'Destination'
  },
  destinations: {
    key: 'destinations',
    name: 'Destinations'
  },
  occupations: {
    key: 'occupations',
    name: 'Occupations'
  },
  vaccine: {
    key: 'vaccine',
    name: 'Vaccine'
  },
  patientRef: {
    key: 'patientRef',
    name: 'Patient REF'
  },
  bactchNo: {
    key: 'bactchNo',
    name: 'Bactch No'
  },
  organisation: {
    key: 'organisation',
    name: 'Organisation'
  },
  practitioners: {
    key: 'practitioners',
    name: 'Practitioners'
  },
  includeVaccineIncome: {
    key: 'includeVaccineIncome',
    name: 'Include Vaccine Income'
  },
  includeConsultationIncome: {
    key: 'includeConsultationIncome',
    name: 'Include Consultation Income'
  },
  productCategories: {
    key: 'productCategories',
    name: 'Product Categories'
  },
  type: {
    key: 'type',
    name: 'Type'
  },


};
export const visibleFields = {
  centre: false,
  startDate: false,
  endDate: false,
  currency: false,
  gender: false,
  ageGroup: false,
  group: false,
  destination: false,
  destinations: false,
  occupations: false,
  vaccine: false,
  patientRef: false,
  bactchNo: false,
  organisation: false,
  productCategories: false,
  includeConsultationIncome: false,
  includeVaccineIncome: false,
  practitioners: false,
  type: false
};
export const controlNameList = ['centre', 'startDate', 'endDate', 'currency', 'gender',
  'ageGroup', 'group', 'destination', 'occupations', 'vaccine', 'patientRef', 'bactchNo', 'type', 'organisation',
  'practitioners', 'productCategories', 'includeConsultationIncome', 'includeVaccineIncome'];
export const reportTypePermission = {
  IndividualAccounts: ['centre', 'startDate', 'endDate', 'currency'],
  TopOccupations: ['centre', 'startDate', 'endDate', 'gender', 'group', 'ageGroup'],
  TopDestinations: ['centre', 'startDate', 'endDate', 'gender', 'group', 'ageGroup', 'destination', 'occupations'],
  VaccineBatchNos: ['centre', 'startDate', 'endDate', 'vaccine', 'patientRef', 'bactchNo'],
  PatientNumbers: ['centre', 'startDate', 'endDate'],
  VaccinePriceList: ['centre', 'startDate', 'endDate', 'currency'],
  AssociateClinic: ['centre', 'startDate', 'endDate', 'currency'],
  EOD: ['centre', 'startDate', 'endDate', 'currency'],
  Statement: ['centre', 'startDate', 'endDate', 'currency', 'organisation'],
  WithholdingTax: ['centre', 'startDate', 'endDate', 'currency', 'organisation'],
  CompanySales: ['centre', 'startDate', 'endDate', 'currency', 'organisation'],
  DoctorIncomeAnalysis: ['centre', 'startDate', 'endDate', 'currency', 'practitioners',
    'productCategories', 'includeConsultationIncome', 'includeVaccineIncome'],
  PaymentsReceived: ['centre', 'startDate', 'endDate', 'currency', 'patientRef', 'type', 'organisation'],
  Debtors: ['centre', 'startDate', 'endDate', 'currency'],
  DebtorsGroupedByCentre: ['centre', 'startDate', 'endDate', 'currency'],
  SalesAnalysis: ['centre', 'startDate', 'endDate', 'currency'],
  EmployeeVaccination: ['centre', 'startDate', 'endDate', 'organisation', 'type', 'patientRef'],
  BadDebt: ['centre', 'startDate', 'endDate', 'currency']
};



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/report/report.service.ts